import React, { useState, useEffect } from 'react';
import { Tooltip, IconButton, Grid, FormControlLabel, Switch } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Helmet from 'react-helmet';

import {
    Portlet,
    PortletBody,
    PortletHeader,
} from "../../../partials/content/Portlet";
import { PagedTable } from '../../../common';

const DEFAULT_SORT = [{ id: 'payerName', direction: 'asc' }];
const SHOW_SEARCH_FILTERS = true;

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    button: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },

    icon: {
        fontSize: 17,
        marginTop: 1,
    }
}));

export default function PricerProgressComponent(props) {
    const {
        pricerProgressListPending, pricerProgressData, pricerProgressFields,
        actions: {
            pricerProgressLanding,
            searchGetByName,
            searchReset,
            resetPagedTable,
            setList
        }
    } = props;

    useEffect(() => {
        const pageName = {
            name: 'pricer-progress-landing'
        }
        searchGetByName(pageName);

        return function cleanup() {
            searchReset();
            resetPagedTable(pageName.name);
        }
    }, [searchGetByName]);

    const [refresh, setRefresh] = useState(Promise.resolve());
    const classes = useStyles();


    function handleLoad(sort, filter, pagination) {
        pricerProgressLanding(pagination, sort, filter);
    }

    function handleRefresh() {
        setRefresh(Promise.resolve());
    }

    return (
        <>
            <Helmet title={`Pricer Statistics`} />
            <Portlet>
                <PortletHeader
                    title={`Pricer Statistics`}
                    handleRefresh={handleRefresh}
                    showSearchFilters={SHOW_SEARCH_FILTERS}
                    showSearchFiltersDropdown={false}
                    name="pricer-progress-landing"
                    includeAdvanceFilters
                />
                <PortletBody>
                    <div className="row">
                        <div className="col-md-12">
                            <PagedTable
                                name="pricer-progress-landing"
                                fields={pricerProgressFields}
                                data={pricerProgressData}
                                onLoad={handleLoad}
                                refresh={refresh}
                                defaultSort={DEFAULT_SORT}
                                title={`Pricer Statistics`}
                                showSearchFilters={SHOW_SEARCH_FILTERS}
                            />
                        </div>
                    </div>
                </PortletBody>
            </Portlet>
        </>
    );
}